import { create } from 'zustand';
import { graphqlApi } from '../api/api';

const useCountryStore = create((set) => ({
  data: {},
  loading: false,
  error: null,

  fetchData: async () => {
    set({ loading: true, error: null });
    try {
      const response = await graphqlApi();
      set({ data: response?.data?.data || {}, loading: false });
    } catch (error) {
      set({ error: 'Failed to fetch data', loading: false });
      console.error('Error fetching data:', error);
    }
  },
}));

export default useCountryStore;